import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { routeSelection, selectedNavRouteAtom } from '../../common/atom/atoms';
import { useAtomValue, useSetAtom } from 'jotai';
import Swal from 'sweetalert2';
const AddRouteButton = (props) => {
  const { setCreateRoutePopup } = props;
  const { map } = props;
  const setRouteSelection = useSetAtom(routeSelection);
  const routeOpenAlready = useAtomValue(selectedNavRouteAtom);
  const handleRouteSelection = () => {
    if (routeOpenAlready) {
      Swal.fire({
        title: 'Action Not Allowed',
        text: 'Please deselect the current route before proceeding.',
        icon: 'info',
      });
      return;
    }
    setCreateRoutePopup(true);
    setRouteSelection(true);
  };
  return (
    <div
      onClick={handleRouteSelection}
      style={{
        position: 'absolute',
        top: '10px',
        right: '30px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1,
        marginBottom: '30px',
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          background: '#c41a1f',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease-in-out',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#c41a1f';
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#c41a1f';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <AddIcon style={{ color: 'white' }} />
      </div>
    </div>
  );
};

export default AddRouteButton;
